import { render, staticRenderFns } from "./ShippingAddressAdd.vue?vue&type=template&id=0bfe6b07&scoped=true&"
import script from "./ShippingAddressAdd.vue?vue&type=script&lang=js&"
export * from "./ShippingAddressAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe6b07",
  null
  
)

export default component.exports